import { render, staticRenderFns } from "./currencyViewDetail.vue?vue&type=template&id=64505b6c&scoped=true"
import script from "./currencyViewDetail.vue?vue&type=script&lang=js"
export * from "./currencyViewDetail.vue?vue&type=script&lang=js"
import style0 from "./currencyViewDetail.vue?vue&type=style&index=0&id=64505b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64505b6c",
  null
  
)

export default component.exports